const data = {
  'Selected': 'Valitud: {0} of {1}',
  'Uploading files': 'Üleslaadimine {0}% of {1}',
  'File size error': '{0} on liiga suur, palun laadige faile üles vähem kui {1}',
  'Upload failed': '{0} üleslaadimine nurjus',
  'Per page': '{0} Lehekülje kohta',
  'Folder': 'Kaust',
  'Login failed, please try again': 'Sisselogimine ebaõnnestus, proovige uuesti',
  'Already logged in': 'Juba sisse logitud.',
  'Please enter username and password': 'Palun sisestage kasutajanimi ja parool.',
  'Not Found': 'Ei leitud',
  'Not Allowed': 'Pole lubatud',
  'Please log in': 'Palun logi sisse',
  'Unknown error': 'Tundmatu viga',
  'Add files': 'Failide lisamine',
  'New': 'Uus',
  'New name': 'Uus nimi',
  'Username': 'Kasutajanimi',
  'Password': 'Salasõna',
  'Login': 'Logi sisse',
  'Logout': 'Logi välja',
  'Profile': 'Profiil',
  'No pagination': 'Ei mingit lehitsemist',
  'Time': 'Aeg',
  'Name': 'Nimi',
  'Size': 'Suurus',
  'Home': 'Avaleht',
  'Copy': 'Kopeeri',
  'Move': 'Lõika',
  'Rename': 'Muuda',
  'Required': 'Palun täida see väli',
  'Zip': 'Zip',
  'Batch Download': 'Paki allalaadimine',
  'Unzip': 'Unzip',
  'Delete': 'Kustuta',
  'Download': 'Allalaadimine',
  'Copy link': 'Kopeeri link',
  'Done': 'Valmis',
  'File': 'Fail',
  'Drop files to upload': 'Failide üleslaadimine',
  'Close': 'Sulge',
  'Select Folder': 'Vali kaust',
  'Users': 'Kasutajad',
  'Files': 'Failid',
  'Role': 'Roll',
  'Cancel': 'Tühista',
  'Paused': 'Peatatud',
  'Confirm': 'Kinnita',
  'Create': 'Loo uus',
  'User': 'Kasutaja',
  'Admin': 'Admin',
  'Save': 'Salvesta',
  'Read': 'Lugema',
  'Write': 'Kirjutama',
  'Upload': 'Laae üles',
  'Permissions': 'Õigused',
  'Homedir': 'Avalehe kaust',
  'Leave blank for no change': 'Jäta tühjaks, et seda ei muudetaks',
  'Are you sure you want to do this?': 'Kas oled kindel, et soovid seda teha?',
  'Are you sure you want to allow access to everyone?': 'Kas oled kindel, et soovid lubada juurdepääsu kõigile?',
  'Are you sure you want to stop all uploads?': 'Kas oled kindel, et soovid kõik üleslaadimised peatada?',
  'Something went wrong': 'Midagi läks valesti',
  'Invalid directory': 'Sobimatu kataloog',
  'This field is required': 'See väli on kohustuslik',
  'Username already taken': 'Kasutajanimi on juba võetud',
  'User not found': 'Kasutajat ei leitud',
  'Old password': 'Vana parool',
  'New password': 'Uus parool',
  'Wrong password': 'Vale parool',
  'Updated': 'Uuendatud',
  'Deleted': 'Kustutatud',
  'Your file is ready': 'Teie fail on valmis',
  'View': 'Vaade',
  'Search': 'Otsing',
  'Download permission': 'Lae alla',
  'Guest': 'Külaline',
  'Show hidden': 'Kuva peidetud',
  'Show symbolic format': 'Kuva sümboolne formaat',
  'Hide symbolic format': 'Peida sümboolne formaat',
}

export default data
